// src/pages/App/landingScroll.js

import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// The landing pages' routes; index.landingScroll.guard.test.js holds them equal to the route table in index.js.
export const LANDING_PATHS = ["/", "/gallery", "/apps", "/labs"];

/** Whether a pathname is a landing page; routes match case-insensitively and with a trailing slash. */
export function isLanding(pathname) {
  return LANDING_PATHS.includes(pathname.toLowerCase().replace(/\/+$/, "") || "/");
}

/** The element a `#hash` names, or null, a malformed one included. */
export function hashTarget(hash) {
  if (!hash) {
    return null;
  }
  try {
    return document.getElementById(decodeURIComponent(hash.slice(1)));
  } catch (err) {
    return null;
  }
}

// A navigation to or from a landing page opens at the top, or at its #hash; POP is the browser's to restore.
// Spec: docs/specs/2026-10-15-front-page.md#21-routes-and-navigation
export default function LandingScroll() {
  const location = useLocation();
  const type = useNavigationType();
  const last = useRef({ key: location.key, pathname: location.pathname });
  // Before paint, so the new page never shows at the old page's depth.
  useLayoutEffect(() => {
    const from = last.current;
    last.current = { key: location.key, pathname: location.pathname };
    if (from.key === location.key || "POP" === type || !(isLanding(from.pathname) || isLanding(location.pathname))) {
      return;
    }
    const target = hashTarget(location.hash);
    if (target) {
      target.scrollIntoView();
    } else {
      window.scrollTo(0, 0);
    }
  }, [location, type]);
  return null;
}
